const LEVELS = new Set(["ordinary", "star"]);
export const UNDER_5000_NOTE = "消费大于5000没有该条权益";

const round = value => Math.round((value + Number.EPSILON) * 10000) / 10000;
const createParty = () => ({ tbc: 0, consumerRights: 0, couponRights: 0 });
const createChannel = () => ({ inviter: createParty(), invitee: createParty(), breakdown: [] });

function cloneChannel(channel) {
  return {
    inviter: { ...channel.inviter },
    invitee: { ...channel.invitee },
    breakdown: channel.breakdown.map(item => ({ ...item }))
  };
}

function addLine(channel, { group, name, formula, party = "inviter", type, amount, eligibilityNote }) {
  const normalized = round(amount);
  channel[party][type] = round(channel[party][type] + normalized);
  channel.breakdown.push({
    id: `${group}-${name}-${party}-${type}-${channel.breakdown.length}`,
    group,
    name,
    formula,
    party,
    type,
    amount: normalized,
    ...(eligibilityNote ? { eligibilityNote } : {})
  });
}

function validatePercentage(value, label, missing) {
  if (value === undefined || value === null || value === "") {
    missing.push(`请填写${label}`);
    return null;
  }
  const number = Number(value);
  if (!Number.isFinite(number) || number < 0 || number > 100) {
    throw new RangeError(`${label}必须在0至100之间`);
  }
  return number / 100;
}

function addBuyerBenefits(channel, contribution, inviteeLevel) {
  if (inviteeLevel === "ordinary") {
    addLine(channel, {
      group: "会员基础权益",
      name: "普通会员自购消费者权益",
      formula: `${contribution} × 100%`,
      party: "invitee",
      type: "consumerRights",
      amount: contribution
    });
    return;
  }
  addLine(channel, {
    group: "会员基础权益",
    name: "星级会员自购TBC",
    formula: `${contribution} × 100%`,
    party: "invitee",
    type: "tbc",
    amount: contribution
  });
  addLine(channel, {
    group: "会员基础权益",
    name: "星级会员消费券权益",
    formula: `${contribution} × 100%`,
    party: "invitee",
    type: "couponRights",
    amount: contribution
  });
}

function addReferralBenefits(channel, input) {
  const { contribution: c, inviterLevel, inviteeLevel, upgradedFromThisRelation } = input;
  if (inviterLevel === "ordinary") {
    addLine(channel, {
      group: "个人直推",
      name: "普通会员推广消费者权益",
      formula: `${c} × 10%`,
      type: "consumerRights",
      amount: c * 0.1
    });
    return;
  }
  if (inviteeLevel === "ordinary") {
    addLine(channel, {
      group: "个人直推",
      name: "星级推广首段TBC",
      formula: `${c} × 50%`,
      type: "tbc",
      amount: c * 0.5,
      eligibilityNote: UNDER_5000_NOTE
    });
    addLine(channel, {
      group: "个人直推",
      name: "星级推广持续TBC",
      formula: `${c} × 10% × 50%`,
      type: "tbc",
      amount: c * 0.05
    });
    addLine(channel, {
      group: "个人直推",
      name: "星级推广持续消费者权益",
      formula: `${c} × 10% × 50%`,
      type: "consumerRights",
      amount: c * 0.05
    });
    return;
  }
  if (upgradedFromThisRelation) {
    addLine(channel, {
      group: "个人直推",
      name: "原普通会员升级后持续TBC",
      formula: `${c} × 5%`,
      type: "tbc",
      amount: c * 0.05
    });
    addLine(channel, {
      group: "个人直推",
      name: "原普通会员升级后持续消费者权益",
      formula: `${c} × 5%`,
      type: "consumerRights",
      amount: c * 0.05
    });
  }
}

function relationshipRate(inviterLevel, inviteeLevel, rates) {
  if (inviterLevel === "ordinary" && inviteeLevel === "ordinary") return rates.ordinaryOrdinary;
  if (inviterLevel === "ordinary" && inviteeLevel === "star") return rates.ordinaryStar;
  if (inviterLevel === "star" && inviteeLevel === "ordinary") return rates.starOrdinary;
  return 0;
}

function addPartnerBenefits(channel, input, isPrivate, ratio) {
  const c = input.contribution;
  if (isPrivate) {
    addLine(channel, {
      group: "合伙人权益",
      name: "私域常规消费者权益",
      formula: `${c} × 12% × 80% × 70% × ${input.directSharePct}%`,
      type: "consumerRights",
      amount: c * 0.0672 * ratio
    });
    addLine(channel, {
      group: "合伙人权益",
      name: "私域常规TBC",
      formula: `${c} × 10% × 30% × 70% × ${input.directSharePct}%`,
      type: "tbc",
      amount: c * 0.021 * ratio
    });
    const conditionalRate = relationshipRate(input.inviterLevel, input.inviteeLevel, {
      ordinaryOrdinary: 0.56,
      ordinaryStar: 0.056,
      starOrdinary: 0.21
    });
    if (conditionalRate) {
      addLine(channel, {
        group: "合伙人权益",
        name: "私域身份分情况TBC",
        formula: `${c} × ${round(conditionalRate * 100)}% × ${input.directSharePct}%`,
        type: "tbc",
        amount: c * conditionalRate * ratio,
        ...(input.inviteeLevel === "ordinary" ? { eligibilityNote: UNDER_5000_NOTE } : {})
      });
    }
    return;
  }
  addLine(channel, {
    group: "合伙人权益",
    name: "公域常规消费者权益",
    formula: `${c} × 10% × 80% × 70% × ${input.directSharePct}%`,
    type: "consumerRights",
    amount: c * 0.056 * ratio
  });
}

function addCityBenefits(channel, input, isPrivate, ratio) {
  const c = input.contribution;
  if (isPrivate) {
    addLine(channel, {
      group: "市级发起人权益",
      name: "市公司私域消费者权益",
      formula: `${c} × 12% × 80% × 30%`,
      type: "consumerRights",
      amount: c * 0.0288
    });
    addLine(channel, {
      group: "市级发起人权益",
      name: "市公司私域TBC",
      formula: `${c} × 10% × 30% × 30%`,
      type: "tbc",
      amount: c * 0.009
    });
    const conditionalRate = relationshipRate(input.inviterLevel, input.inviteeLevel, {
      ordinaryOrdinary: 0.24,
      ordinaryStar: 0.024,
      starOrdinary: 0.09
    });
    if (conditionalRate) {
      addLine(channel, {
        group: "市级发起人权益",
        name: "市公司私域身份分情况TBC",
        formula: `${c} × ${round(conditionalRate * 100)}%`,
        type: "tbc",
        amount: c * conditionalRate,
        ...(input.inviteeLevel === "ordinary" ? { eligibilityNote: UNDER_5000_NOTE } : {})
      });
    }
    if (input.cityProvinceActive) {
      addLine(channel, {
        group: "市级发起人权益",
        name: "省公司私域消费者权益",
        formula: `${c} × 12% × 15% × ${input.citySharePct}%`,
        type: "consumerRights",
        amount: c * 0.018 * ratio
      });
      addLine(channel, {
        group: "市级发起人权益",
        name: "省公司私域TBC",
        formula: `${c} × 10% × 15% × ${input.citySharePct}%`,
        type: "tbc",
        amount: c * 0.015 * ratio
      });
      if (input.inviteeLevel === "ordinary") {
        addLine(channel, {
          group: "市级发起人权益",
          name: "省公司未满5000普通用户TBC",
          formula: `${c} × 15% × 70% × ${input.citySharePct}%`,
          type: "tbc",
          amount: c * 0.105 * ratio,
          eligibilityNote: UNDER_5000_NOTE
        });
      }
    }
    return;
  }
  addLine(channel, {
    group: "市级发起人权益",
    name: "市公司公域消费者权益",
    formula: `${c} × 10% × 80% × 30%`,
    type: "consumerRights",
    amount: c * 0.024
  });
  if (input.cityProvinceActive) {
    addLine(channel, {
      group: "市级发起人权益",
      name: "省公司公域消费者权益",
      formula: `${c} × 10% × 15% × ${input.citySharePct}%`,
      type: "consumerRights",
      amount: c * 0.015 * ratio
    });
  }
}

function addProvinceBenefits(channel, input, isPrivate) {
  const c = input.contribution;
  if (isPrivate) {
    addLine(channel, {
      group: "省级发起人权益",
      name: "省公司私域消费者权益",
      formula: `${c} × 12% × 15% × 30%`,
      type: "consumerRights",
      amount: c * 0.0054
    });
    addLine(channel, {
      group: "省级发起人权益",
      name: "省公司私域TBC",
      formula: `${c} × 10% × 15% × 30%`,
      type: "tbc",
      amount: c * 0.0045
    });
    if (input.inviteeLevel === "ordinary") {
      addLine(channel, {
        group: "省级发起人权益",
        name: "未满5000普通用户TBC",
        formula: `${c} × 15% × 30%`,
        type: "tbc",
        amount: c * 0.045,
        eligibilityNote: UNDER_5000_NOTE
      });
    }
    return;
  }
  addLine(channel, {
    group: "省级发起人权益",
    name: "省公司公域消费者权益",
    formula: `${c} × 10% × 15% × 30%`,
    type: "consumerRights",
    amount: c * 0.0045
  });
}

function addRegionBenefits(channel, input, isPrivate) {
  const c = input.contribution;
  if (isPrivate) {
    addLine(channel, {
      group: "大区权益",
      name: "省公司私域消费者权益",
      formula: `${c} × 12% × 5%`,
      type: "consumerRights",
      amount: c * 0.006
    });
    addLine(channel, {
      group: "大区权益",
      name: "省公司私域TBC",
      formula: `${c} × 10% × 5%`,
      type: "tbc",
      amount: c * 0.005
    });
  } else {
    addLine(channel, {
      group: "大区权益",
      name: "省公司公域消费者权益",
      formula: `${c} × 10% × 5%`,
      type: "consumerRights",
      amount: c * 0.005
    });
  }
  if (input.inviteeLevel === "ordinary") {
    addLine(channel, {
      group: "大区权益",
      name: "下属省公司未满5000普通用户TBC",
      formula: `${c} × 5%`,
      type: "tbc",
      amount: c * 0.05,
      eligibilityNote: UNDER_5000_NOTE
    });
  }
}

function addRoleBenefits(channel, input, isPrivate, ratios) {
  const roles = new Set(input.inviterRoles);
  if (roles.has("partner")) addPartnerBenefits(channel, input, isPrivate, ratios.partner);
  if (roles.has("city")) addCityBenefits(channel, input, isPrivate, ratios.city);
  if (roles.has("province")) addProvinceBenefits(channel, input, isPrivate);
  if (roles.has("region")) addRegionBenefits(channel, input, isPrivate);
}

export function calculateScenario(rawInput) {
  const contribution = Number(rawInput.contribution);
  if (!Number.isFinite(contribution) || contribution <= 0) throw new RangeError("贡献值必须大于0");
  if (!LEVELS.has(rawInput.inviterLevel) || !LEVELS.has(rawInput.inviteeLevel)) {
    throw new TypeError("请选择有效的会员等级");
  }
  const input = {
    ...rawInput,
    contribution,
    inviterRoles: Array.isArray(rawInput.inviterRoles) ? rawInput.inviterRoles : []
  };
  const roles = new Set(input.inviterRoles);
  const missing = [];
  const partner = roles.has("partner")
    ? validatePercentage(input.directSharePct, "合伙人个人直推销售占比", missing)
    : null;
  const city = roles.has("city") && input.cityProvinceActive
    ? validatePercentage(input.citySharePct, "市级销售占比", missing)
    : null;
  if (input.inviterLevel === "star" && input.inviteeLevel === "star" && !input.upgradedFromThisRelation) {
    missing.push("请确认被邀请人是否由本邀请关系从普通会员升级为星级会员");
  }
  if (missing.length) return { private: null, public: null, missing };

  const base = createChannel();
  addBuyerBenefits(base, contribution, input.inviteeLevel);
  addReferralBenefits(base, input);
  const privateResult = cloneChannel(base);
  const publicResult = cloneChannel(base);
  addRoleBenefits(privateResult, input, true, { partner, city });
  addRoleBenefits(publicResult, input, false, { partner, city });
  return { private: privateResult, public: publicResult, missing: [] };
}
